import { Component } from 'react';
import ConversationTemplate from './Templates/ChatTemplate';
import Popup from 'Components/Common/PopUp';
import Request from 'Services/request';
import { convertUTCTOLocalTimeStamp } from 'Components/Common/TimeStamp';
import routesPath from 'Constants/routes.constants';
import validation from 'Helpers/Validation';
import { validator } from 'Helpers/validator';
import { ReactComponent as BaclArrow } from 'assets/images/svg/Left Arrow.svg';
import dateFormat from 'dateformat';
import LoadingOverlay from 'react-loading-overlay';
import { toast as toastr } from 'react-toastify';
import { decryptData } from 'Helpers/cryptLib';
export default class ReplyFeedback extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: '',
      description: '',
      loading: false,
      filtered: [],
      showError: false,
      errorElement: '',
      replyFeedback: '',
      isPopupOpen: false,
      messageArray: [],
      isBlocked:0
    };
    this.validator = validator.getInstance();
  }

  /**
   * @method validation
   * @summary validate the inputs based on validation rules
   * @param {event} event - React onBlur event
   * @return {none} undefined
   */

  validation = (e) => {
    validation(e, 'add-team-form');
  };

  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [ name ]: value });
  };

  componentDidMount() {
    var usernamelocationn = window.location.pathname
    var Id = usernamelocationn.replace('/reports/', '');
    this.setState({ id: Id }, () => {
      this.props.FeedbackDetails(this.state.id)
    })
  }

  componentDidUpdate(prevProps) {
    if (prevProps.feedbackDetails !== this.props.feedbackDetails) {
       this.setState({ 
        messageArray: this.props.feedbackDetails.messages,
        isBlocked:this.props?.feedbackDetails?.isBlocked
      })
     }
  }

  closeForm = () => {
    this.props.closeForm();
  };

  handleSubmit = (event) => {
    event.preventDefault();
    const { id, description } = this.state;
    this.setState({ showError: false }, () => {
          return this.props.FeedbackDetails( { description, id }, this.props.filterVal);
    });
  };  
  handleBack = () => {
    this.props.history.push(routesPath.report)
  }
  BlockUserpopup = () => {
    this.setState({ isPopupOpen: false })
  }
  toggleblockUser = () => {

    const { feedbackDetails: { reportedMobile } = { } } = this.props;
    const { isBlocked }  = this.state
    if(!reportedMobile) {
       toastr.error('Reported Mobile Number is Requied')
       return
    }
    Request.update(`/reports/action`,{
        reportedUser:reportedMobile,
        isBlocked:isBlocked === 1 ? 0 : 1
    })
    .then((response) => {
      const { message, data: { isBlocked } } = response;
      toastr.dismiss();
      toastr.success(message);
      this.setState({ 
        isPopupOpen: false, 
        isBlocked 
      } )
    }).catch((error)=>{
       toastr.error(error.toString());
    })
  }
  ClickblockUser = () => {
    this.setState({ isPopupOpen: true })
  }
  render() {
    const {  messageArray, isBlocked } = this.state;
    const { formLoading } = this.props;
    const { feedbackDetails = { } } = this.props
    console.log('Reply Feedback ',feedbackDetails);
    
    let reporter=feedbackDetails.reporterEmail 
    // const encryptKey=feedbackDetails.reporterMobile
        reporter=decryptData(reporter)
        console.log('reporter',reporter);
        
        let reported=feedbackDetails.reportedEmail
        // const encryptKeyy=feedbackDetails.reportedMobile
        reported=decryptData(reported) 
        console.log('reported',reported);
          
           let {
      reportedTime,
      reportedMobile,
      reporterMobile,
      type
    }  = feedbackDetails

    if (reportedTime) {
      const val = reportedTime && reportedTime.replace('T',' ')
      const time = reportedTime && convertUTCTOLocalTimeStamp(val)
      var formatDate =  dateFormat(time, 'mmm d, yyyy / hh:MM:ss TT ')
    }
    if (reportedMobile) {
      const phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance();
      let numberProto = phoneUtil.parse(`+${ reportedMobile }`, '');
      var mobile = phoneUtil.formatOutOfCountryCallingNumber(numberProto, '');
    }
    if (reporterMobile) {
      const phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance();
      let numberProto = phoneUtil.parse(`+${ reporterMobile }`, '');
      reporterMobile = phoneUtil.formatOutOfCountryCallingNumber(numberProto, '');
    }
  
    const isChat = type === 'chat'
    return (
      <>
        <div className='pageContainer_inner'>
        <LoadingOverlay
          active={ formLoading }
          spinner
          styles={ {
            wrapper: {
              width: '100%',
              textAlign: '-webkit-center',
            },
          } }
          text='Please wait...'
        ></LoadingOverlay>
          <div>
            <div className='heading-block gap-10'>
              <div className='block_flex'>
                <h4><i className='back_arrow_icon' onClick={ () => this.handleBack() }><BaclArrow/></i></h4>
                <h4>{ `ID - ${ this.state.id } ` }</h4>
              </div>
            { isChat && <div className='button_wrapper'>
                <button type='button' className= { `btn btn_primary` }  onClick={ this.ClickblockUser }>{ `${ isBlocked ? 'Unblock User' : 'Block User' }` }</button>
              </div> }
            </div>
            <div className='main-block report_page p-0'>
              <form>
                <div className='pageContent'>
                  <div className='report_block'>
                    <h5 className='form_heading_text'>Reporter</h5>
                    <div className='ctformgrouptext'>
                      <label>Name:</label>
                      <span>{ feedbackDetails.reporterUsername }</span>
                    </div>
                    <div className='ctformgrouptext'>
                      <label>Email Address:</label>
                      <span>{ reporter }</span>
                    </div>
                    <div className='ctformgrouptext'>
                      <label>Mobile Number:</label>
                      <span>{ reporterMobile  }</span>
                    </div>
                    <h5 className='form_heading_text mt-30'>Report Details</h5>
                    { isChat && (
                      <div>
                      <div className='ctformgrouptext'>
                      <label>Name</label>
                      <span>{  feedbackDetails.reportedUsername }</span>
                    </div>
                    <div className='ctformgrouptext'>
                      <label>Email Address:</label>
                      <span>{ reported }</span>
                    </div>
                    <div className='ctformgrouptext'>
                      <label>Mobile Number:</label>
                      <span>{ mobile }</span>
                        </div>
                        </div>
                    )}
                    { feedbackDetails.type === 'groupchat' && (
                      <div className='ctformgrouptext'>
                        <label>Group Name:</label>
                        <span>{ feedbackDetails.groupName }</span>
                      </div>
                    )}
                    <div className='ctformgrouptext'>
                      <label>Reported Time:</label>
                      <span>{ formatDate }</span>
                    </div>
                    <div className='ctformgrouptext'>
                      <label>Type:</label>
                      <span>{ isChat ? 'Chat' : 'Group Chat' }</span>
                    </div>
                  </div>
                  <div className='report_con_block'>
                    <h5>Reported Chats</h5>
                    <div className='report_conver_wrp'>
                      <ConversationTemplate feedbackDetails= { feedbackDetails } chatmessages={ messageArray } />
                     </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
       { this.state.isPopupOpen &&
        <Popup
					popupText= { `Are you sure you want to ${ isBlocked ? 'Unblock' : 'Block' } this user?` }
					handleYes={ this.toggleblockUser }
					handleCancel={ this.BlockUserpopup }
				/>
       }
      </>
    );
  }
}
